import { LoginStatus } from './login.status';
import { ActionReducerMap, createSelector, createFeatureSelector } from '@ngrx/store';
import * as login from './core.reducer';

export interface LoginState {
  webApp: login.WebAppLoginState;
  direct: login.DirectLoginState;
}

export const indexLoginReducers: ActionReducerMap<LoginState> = {
  webApp: login.coreWebappReducer,
  direct: login.coreDirectReducer
};

export const loginSelector = createFeatureSelector<any>('login');

const getDirectGetter = state => state.direct;
const directLoginTokenGetter = state => state.direct.directToken;
const directLoginProfileGetter = state => state.direct.profile;
const directLoginClpResponse = state => state.direct.clpResponse;
const directSessionBanner = state => state.direct.sessionBanner;
const directLoginStatus = state => state.direct.loginStatus;
const directLoginParametersStatus = state => state.direct.parameters;
const localeList = state => state.direct.localeList;
const loginLoading = state => state.direct._isLoading;

const homepage = state => state.homepage;
const menuListState = state => state.menu;

export const getDirectLoginToken = createSelector(loginSelector, directLoginTokenGetter);
export const getDirectLoginProfile = createSelector(loginSelector, directLoginProfileGetter);
export const getDirectLoginClpResponse = createSelector(loginSelector, directLoginClpResponse);
export const getDirectSessionBanner = createSelector(loginSelector, directSessionBanner);
export const getDirectLoginStatus = createSelector(loginSelector, directLoginStatus);
export const getDirectLoginParametersStatus = createSelector(loginSelector, directLoginParametersStatus);
export const getLocaleListState = createSelector(loginSelector, localeList);
export const getLoginLoadingState = createSelector(loginSelector, loginLoading);

export const getDirectState = createSelector(loginSelector, getDirectGetter);
export const getMenuListState = createSelector(homepage, menuListState);
export const selectClpConfig = createSelector(loginSelector, (state: LoginState) => state.direct.clpConfig);

export const getDirectLogin = createSelector(loginSelector, loginState => loginState.direct);
export const getDirectLoggedIn = createSelector(
  getDirectLogin,
  directLogin => directLogin.loginStatus === LoginStatus.LOGIN && +directLogin.code === 0
);
export const getDirectTokenPermissions = createSelector(
  getDirectLogin,
  directLoginState => directLoginState.permissions
);

export const getError = createSelector(loginSelector, loginState => loginState.direct.errorModel);

export const selectLoginUiState = createSelector(getDirectLogin, directLoginState => directLoginState.uiState);
